import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { VIDEO_TYPE_LABEL } from "@/types/video";

interface VideoCardProps {
  video: Video;
  showType?: boolean;
  index?: number;
}

export default function VideoCard({ video, showType = false, index = 0 }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block overflow-hidden rounded-lg border border-background-800 bg-background-900 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/70"
      style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-800">
        <img
          src={video.poster}
          alt={video.title}
          title={`${video.title} - ${VIDEO_TYPE_LABEL[video.type]}高清在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-transparent to-transparent"></div>
        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-950">
          {video.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-950/80 px-2 py-0.5 text-[11px] font-medium text-accent-400">
          <i className="ri-star-fill text-[10px]"></i>
          {video.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between px-2.5 pb-2">
          <span className="rounded bg-background-950/70 px-1.5 py-0.5 text-[11px] text-foreground-200">
            {showType ? VIDEO_TYPE_LABEL[video.type] : video.genres[0]}
          </span>
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-background-950 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <i className="ri-play-fill text-sm"></i>
          </span>
        </div>
      </div>
      <div className="px-2.5 py-2.5">
        <h3 className="clamp-1 text-sm font-medium text-foreground-100 transition-colors group-hover:text-primary-400">
          {video.title}
        </h3>
        <p className="clamp-1 mt-1 text-xs text-foreground-500">
          {video.year} · {video.region} · {video.genres.join(" / ")}
        </p>
      </div>
    </Link>
  );
}